<template>
  <div class="introducer-report">
        <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-date"></i> Introducer Downline</span>
        <div style="float:right; margin-left:5px">
          <el-button icon="el-icon-download" type="success" @click="ExcelReport()">Excel</el-button>
          <el-button icon="el-icon-download" type="danger" @click="PDFReport()">PDF</el-button>
        </div>
        <DownlineForm style="float:right" v-on:submited="getDownline()"/>
      </div>


      <data-tables 
          v-loading="loading" 
          :data="dataTable" 
          border 
          :page-size="20"
          :pagination-props="{ background: true, pageSizes: [20, 50, 100, 200] }">
          <el-table-column prop="customer_code" label="Introducer Code" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="customer_name" label="Customer Name" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="customer_status" label="Status" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="created_date" label="Approve Date" header-align="center" align="center"> </el-table-column>
         <el-table-column prop="enduser_id" label="Action" header-align="center" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="removeDownline(scope.row.enduser_id)">Remove</el-button>
            </template>
          </el-table-column>
        </data-tables>
    </el-card>
    
  </div>
</template>

<script>
import DownlineForm from './downline-form'
import { getDownline, delDownline, reportDownlineExcel, reportDownlinePDF } from '@/api/introducer'
export default {
  components:{
    DownlineForm
  },
  props:{
    projectUID: String
  },
  data(){
    return{
      loading: false,
      dataTable:[]
    }
  },
  methods:{
    getDownline(){
      this.loading = true;
      getDownline(this.$route.params.customer_uid).then(({result, data})=>{
        this.loading = false
        if(result){
          this.dataTable = data;
        }
      })
    },
    removeDownline(enduser_id){
      this.$confirm('Are you sure you want to delete this Introducer, Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          delDownline(this.$route.params.customer_uid, {enduser_id:enduser_id}).then(({ result}) =>{
            if(result){
              this.$notify({
                title: 'Success',
                message: `Delete Customer successfully`,
                type: 'success',
                duration: 2000
              });
              this.getDownline()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });          
        });
    },
    ExcelReport(){
      reportDownlineExcel(this.$route.params.customer_uid);
    },
    PDFReport(){
      reportDownlinePDF(this.$route.params.customer_uid);
    }
  },
  created(){
    this.getDownline()
  }

}
</script>

<style>

</style>